export const TEMPLATE_STATUS_TYPE = {
  /* eslint no-useless-computed-key: "off" */
  ['0']: '审核中',
  ['1']: '审核通过',
  ['2']: '审核未通过'
}
